<div class="avatar" [style.width.px]="size" [style.height.px]="size">
  <!-- Entity Image -->
  @if (imageUrl && !imageError) {
    <img 
      [src]="imageUrl" 
      [alt]="getEntityName()"
      class="avatar-image"
      (load)="onImageLoad()"
      (error)="onImageError()"
      [style.display]="showImage ? 'block' : 'none'">
  }
  
  <!-- Initials Fallback -->
  @if ((!showImage || imageError) && showInitials) {
    <div 
      class="avatar-initials"
      [style.background-color]="backgroundColor"
      [style.font-size.px]="size * 0.4">
      {{ initials }}
    </div>
  }
</div>
